/* global axios */
import ApiClient from './ApiClient';

class MetaAdsAPI extends ApiClient {
  constructor() {
    super('meta_ads', {
      accountScoped: true,
    });
  }

  getConfig() {
    return axios.get(`${this.url}/config`);
  }

  saveConfig(data) {
    return axios.post(`${this.url}/config`, data);
  }

  deleteConfig() {
    return axios.delete(`${this.url}/config`);
  }

  testConnection() {
    return axios.post(`${this.url}/test_connection`);
  }

  connect(token) {
    return axios.post(`${this.url}/connect`, { token });
  }

  datasets() {
    return axios.get(`${this.url}/datasets`);
  }

  // Login de negócios da Meta: cria a conta de anúncios que destrava a lista
  // de pixels e o envio de conversões sem token.
  adsLoginUrl() {
    return axios.post(`${this.url}/ads_login_url`);
  }

  syncNow() {
    return axios.post(`${this.url}/sync`);
  }

  getDashboard(params = {}) {
    return axios.get(`${this.url}/dashboard`, { params });
  }

  getCampaigns(params = {}) {
    return axios.get(`${this.url}/campaigns`, { params });
  }

  // Caminho Zernio (conexão pelo Estúdio Social, sem App Review)
  getZernioAdAccounts() {
    return axios.get(`${this.url}/zernio_ad_accounts`);
  }

  zernioConnect(data) {
    return axios.post(`${this.url}/zernio_connect`, data);
  }

  getZernioInsights(params = {}) {
    return axios.get(`${this.url}/zernio_insights`, { params });
  }

  getAttributions(params = {}) {
    return axios.get(`${this.url}/attributions`, { params });
  }

  getCapiEvents(params = {}) {
    return axios.get(`${this.url}/capi_events`, { params });
  }

  getCapiDiagnostics() {
    return axios.get(`${this.url}/capi_diagnostics`);
  }

  sendTestEvent() {
    return axios.post(`${this.url}/send_test_event`);
  }

  reprocessAttributions() {
    return axios.post(`${this.url}/reprocess_attributions`);
  }

  chat(data) {
    return axios.post(`${this.url}/chat`, data);
  }
}

export default new MetaAdsAPI();
